import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=1a059efc&scoped=true&"
import script from "./questionList.vue?vue&type=script&lang=js&"
export * from "./questionList.vue?vue&type=script&lang=js&"
import style0 from "./questionList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./questionList.vue?vue&type=style&index=1&id=1a059efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a059efc",
  null
  
)

export default component.exports